<template>
  <div id="TypeNameManage">
    <div v-if="TypeNameManageShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <button
          href="#"
          @click="AddTypeName()"
          class="btn btn-outline-success"
          type="button"
          style="font-size: 14px; text-align: right"
        >
          新增競賽種類名稱
        </button>
      </div>

      <b-tabs content-class="mt-3" justified>
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            fixed
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="min-width: 2em">序號</b-th>
                <b-th style="min-width: 26em">競賽種類名稱</b-th>
                <b-th style="min-width: 20em">管理</b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(item, index) in filteredDocs"
                :key="item.sn"
                :index="item.sn"
                :name="item.sn"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <b-td style="text-align: right">
                  {{ item.sn }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.typeName }}
                </b-td>

                <b-td v-if="item.isDelete==false">
                  <button
                    href="#"
                    @click.prevent="EditTypeName(item.sn)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    修改
                  </button>
                  <button
                    href="#"
                    @click.prevent="remove(item.sn)"
                    class="btn btn-outline-danger"
                    type="button"
                    style="font-size: 14px"
                  >
                    隱藏
                  </button>
                </b-td>
                <b-td v-else>
                  <button
                    href="#"
                    @click.prevent="EditTypeName(item.sn)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    修改
                  </button>
                  <button
                    href="#"
                    @click.prevent="display(item.sn)"
                    class="btn btn-outline-danger"
                    type="button"
                    style="font-size: 14px"
                  >
                    顯示
                  </button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            v-if="total > pageSize"
          />
        </div>
      </b-tabs>

      <b-modal size="xl" ref="AddTypeName" hide-footer>
        <template #modal-title> 新增競賽種類名稱 </template>
        <AddTypeName @hideModal="hideModal('AddTypeName')"></AddTypeName>
      </b-modal>
      <b-modal size="xl" ref="EditTypeName" hide-footer>
        <template #modal-title> 修改競賽種類名稱 </template>
        <EditTypeName
          :sn="sn"
          @hideModal="hideModal('EditTypeName')"
        ></EditTypeName>
      </b-modal>
      <b-modal ref="q-modal" hide-footer title="請注意">
        <div class="d-block text-center">
          <h3>是否確認隱藏此筆資料?</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
          >取消隱藏</b-button
        >
        <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
          >隱藏確認</b-button
        >
      </b-modal>
    </div>
  </div>
</template>

<script>
import AddTypeName from '@/components/AddTypeName.vue'
import EditTypeName from '@/components/EditTypeName.vue'
import * as tools from '../tool'
export default {
  name: 'TypeNameManage',
  data () {
    return {
      courseName: null,
      TypeNameManageShow: false,
      sn: 0,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: null,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,

      pageSize: 10
    }
  },
  components: {
    AddTypeName,
    EditTypeName
  },
  methods: {
    getToday (updateTime) {
      var dd = new Date(updateTime)
      var today = dd.getDate().toString().padStart(2, '0') // 內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, '0') // January is 0!
      var yyyy = dd.getFullYear()
      return tools.stringFormat('{0}-{1}-{2}', yyyy, mm, today)
    },

    getAllTypeName () {
      const vm = this
      this.$http
        .get('./WebApi/EconomicDisadvantage/GetAllTypeName/')
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data
            vm.total = vm.inputData.length
            vm.currentPage = 1
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        })
    },
    AddTypeName () {
      var vm = this
      vm.$refs.AddTypeName.show()
    },
    EditTypeName (sn) {
      var vm = this
      vm.sn = sn
      vm.$refs.EditTypeName.show()
    },
    remove (sn) {
      this.sn = sn
      this.$refs['q-modal'].show()
    },
    cancalRM () {
      this.$refs['q-modal'].hide()
    },
    hideModal (name) {
      this.$refs[name].hide()
      this.getAllTypeName()
    },
    confirmRM () {
      // 隱藏資料
      this.$refs['q-modal'].hide()
      var vm = this
      this.$http
        .get('./WebApi/EconomicDisadvantage/RemoveTypeName/'.concat(this.sn))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, 'success', '恭喜您,隱藏成功')
            vm.getAllTypeName()
          } else {
            tools.showAlert(vm, 'danger', '對不起,隱藏失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    },
    display (sn) {
      // display資料
      this.sn = sn
      var vm = this
      this.$http
        .get('./WebApi/EconomicDisadvantage/DisplayTypeName/'.concat(vm.sn))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, 'success', '恭喜您,顯示成功')
            vm.getAllTypeName()
          } else {
            tools.showAlert(vm, 'danger', '對不起,顯示失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    }
  },
  computed: {
    filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },

    headerColor () {
      return '#f7e8aa'
    }
  },
  created () {
    console.log('======created TypeNameManageView =====')
    this.isIE =
      navigator.userAgent.indexOf('MSIE ') > -1 ||
      navigator.userAgent.indexOf('Trident/') > -1 ||
      navigator.userAgent.indexOf('Edge') > -1
    const vm = this

    vm.TypeNameManageShow = true
    vm.getAllTypeName()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
